export default __webpack_public_path__ + "static/media/client_souhail.02c0c037.jpeg";